import React from "react";
import { DndContext, PointerSensor, KeyboardSensor, useSensor, useSensors, closestCenter } from "@dnd-kit/core";
import { SortableContext, useSortable, arrayMove, verticalListSortingStrategy, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";

function Item({ id, children }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  return (
    <div ref={setNodeRef} style={{ transform: CSS.Transform.toString(transform), transition, opacity: isDragging ? 0.6 : 1, zIndex: isDragging ? 20 : undefined, position: "relative" }}>
      {children(
        <button type="button" {...attributes} {...listeners} className="cursor-grab active:cursor-grabbing p-1 text-forest/50 hover:text-forest touch-none" data-testid={`drag-${id}`}>
          <GripVertical className="w-4 h-4" />
        </button>,
      )}
    </div>
  );
}

export function SortableList({ ids, onReorder, children, className = "space-y-1" }) {
  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 4 } }), useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }));
  const onEnd = ({ active, over }) => {
    if (over && active.id !== over.id) onReorder(arrayMove(ids, ids.indexOf(active.id), ids.indexOf(over.id)));
  };
  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onEnd}>
      <SortableContext items={ids} strategy={verticalListSortingStrategy}>
        <div className={className}>{ids.map((id) => <Item key={id} id={id}>{(handle) => children(id, handle)}</Item>)}</div>
      </SortableContext>
    </DndContext>
  );
}
